export default __webpack_public_path__ + "static/media/vestiLoader.75ee3282.gif";